import { Checkbox } from "antd";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const AttributeConfigureOptions = ({
  optionValues, // the options that are rendered as options
  currTaggingState, // what is the selected tagging On (Start/End)
  editPanel,
  setXaxisProp, // passing state for dispatch x-axis
  setBreakdownProp, // passing state for dispatch breakdown
}) => {
  const axisPanelAtt = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  // local states
  const [XaxisObject, setXaxisObject] = useState(axisPanelAtt?.x_axis || {});
  const [breakdownByObject, setBreakdownByObject] = useState(
    axisPanelAtt?.breakdown_by || []
  );
  const [showMinimumFilterError, setShowMinimumFilterError] = useState(false);

  // to update state we need to know index of updation
  let currIndexBreakdown = editPanel?.breakdown_index;
  // X-axis can have multiple taggin on, index tells if user is updating option for start or end
  let currIndexXaxis = 0;
  if (
    editPanel?.series === "x_axis" &&
    XaxisObject?.config_filters.length > 1
  ) {
    if (currTaggingState?.attribute.endsWith("start")) {
      currIndexXaxis = 0;
    } else if (currTaggingState?.attribute.endsWith("end")) {
      currIndexXaxis = 1;
    }
  }

  // to update the tagging On state in the prop that is passed to parent to dispatch
  useEffect(() => {
    if (editPanel?.series === "breakdown") {
      const updatedBreakdownByObject = structuredClone(breakdownByObject);
      const columns =
        updatedBreakdownByObject[currIndexBreakdown].config_filters[0].columns;
      const newColumns = [...columns];
      updatedBreakdownByObject[currIndexBreakdown].config_filters[0].attribute =
        currTaggingState?.attribute;
      setBreakdownByObject(updatedBreakdownByObject);
      setBreakdownProp(updatedBreakdownByObject);
    } else if (editPanel?.series === "x_axis") {
      const updatedXaxisObject = structuredClone(XaxisObject);
      const columns = structuredClone(
        updatedXaxisObject.config_filters[currIndexXaxis].columns
      );

      const newColumns = [...columns];

      updatedXaxisObject.config_filters[currIndexXaxis].columns = newColumns;
      updatedXaxisObject.config_filters[currIndexXaxis].attribute =
        currTaggingState?.attribute;
      setXaxisObject(updatedXaxisObject);
      setXaxisProp(updatedXaxisObject);
    }
  }, [currTaggingState]);

  // to handle apply button even if no changes are made
  useEffect(() => {
    setXaxisProp(XaxisObject);
    setBreakdownProp(breakdownByObject);
  }, []);

  // to update the local states according to the global state to stay in sync with changes
  useEffect(() => {
    setXaxisObject(structuredClone(axisPanelAtt?.x_axis));
    setBreakdownByObject(structuredClone(axisPanelAtt?.breakdown_by));
  }, [axisPanelAtt?.x_axis, axisPanelAtt?.breakdown_by]);

  // function when user clicks on an option
  const onCheckBoxChange = (el) => {
    // console.log("entering oncheckbox function", editPanel);
    if (editPanel?.series === "breakdown") {
      const updatedBreakdownByObject = structuredClone(breakdownByObject);
      const columns =
        updatedBreakdownByObject[currIndexBreakdown].config_filters[0].columns;

      const index = columns.findIndex((column) => column.name === el);
      const newColumns = [...columns];

      if (index > -1) {
        // Remove the column if already selected
        if (columns?.length > 1) {
          newColumns.splice(index, 1);
        } else {
          setShowMinimumFilterError(true);
        }
      } else {
        // Add new column if not already selected
        setShowMinimumFilterError(false);
        newColumns.push({
          name: el,
          type: "include",
          display_name: null,
        });
      }

      updatedBreakdownByObject[currIndexBreakdown].config_filters[0].columns =
        newColumns;
      updatedBreakdownByObject[currIndexBreakdown].config_filters[0].attribute =
        currTaggingState
          ? currTaggingState?.attribute
          : axisPanelAtt?.breakdown_by?.[currIndexBreakdown]?.attribute;
      // update both local and global state

      setBreakdownByObject(updatedBreakdownByObject);
      setBreakdownProp(updatedBreakdownByObject);
    } else if (editPanel?.series === "x_axis") {
      const updatedXaxisObject = structuredClone(XaxisObject);

      const columns = structuredClone(
        updatedXaxisObject.config_filters[currIndexXaxis].columns
      );

      const index = columns.findIndex((column) => column.name === el);
      const newColumns = [...columns];

      if (index > -1) {
        if (columns?.length > 1) {
          newColumns.splice(index, 1);
        } else {
          setShowMinimumFilterError(true);
        }
        // Remove the column if already selected
      } else {
        // Add new column if not selected
        setShowMinimumFilterError(false);
        newColumns.push({
          name: el,
          type: "include",
          display_name: null,
        });
      }

      updatedXaxisObject.config_filters[currIndexXaxis].columns = newColumns;

      if (!currTaggingState === "notJourneyAttribute") {
        updatedXaxisObject.config_filters[currIndexXaxis].attribute =
          currTaggingState?.attribute;
      } else {
        updatedXaxisObject.config_filters[currIndexXaxis].attribute =
          axisPanelAtt?.x_axis?.config_filters?.[currIndexXaxis]?.attribute;
      }
      // update both local and global state

      setXaxisObject(updatedXaxisObject);
      setXaxisProp(updatedXaxisObject);
    }
  };

  return (
    <>
      <div>
        <div style={{ marginLeft: "2rem" }}>Include:</div>
        {showMinimumFilterError ? (
          <div style={{ marginLeft: "2rem" }}>
            Need to select atleast one option
          </div>
        ) : (
          ""
        )}
        <div
          className="custom_scroll1 p-2 mr-1"
          style={{
            maxHeight: "25rem",
            marginLeft: "2rem",
            overflow: "scroll",
            overflowX: "hidden",
          }}
        >
          {optionValues &&
            optionValues.map((el, i) => (
              <div key={i}>
                <Checkbox
                  value={el}
                  checked={
                    editPanel?.series === "breakdown"
                      ? breakdownByObject[
                          currIndexBreakdown
                        ]?.config_filters[0].columns.some(
                          (column) => column.name === el
                        )
                      : XaxisObject?.config_filters[
                          currIndexXaxis
                        ]?.columns.some((column) => column.name === el)
                  }
                  onChange={(e) => onCheckBoxChange(el)}
                >
                  {el}
                </Checkbox>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default AttributeConfigureOptions;
